import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-ghost-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  妖精动漫
                </span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed">
                妖精动漫网官网入口，提供妖精动漫平台最新网站地址，免费在线看韩漫、日漫、国漫全集，支持下拉式阅读，追更收藏一站搞定。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/hanman" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">漫画分类</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-foreground-300">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                  <span>contact@yaojingdongman.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-customer-service-2-line mt-0.5 text-foreground-400"></i>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-shield-check-line mt-0.5 text-foreground-400"></i>
                  <span>正版授权 · 安全阅读</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 妖精动漫网 YaolingDongman.com. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}